import MainWrapper from 'modules/components/MainWrapper';
import IncidentsDashboard from 'modules/incidents/incidents-dashboard/Main';
import Incidents from 'modules/incidents/incidents-log/Main';
import AddIncidents from 'modules/incidents/incidents-log/add-incidents/Main';
import Vulnerabilities from 'modules/vulnerabilities/Main';
import FormVulnerability from 'modules/vulnerabilities/form-vulnerability/Main';
import VulnerabilityDetail from 'modules/vulnerabilities/view-vulnerability/Main';
import { lazy } from 'react';
// const FAQPage = lazy(() => import('modules/authentication/components/FAQPage'));
const IncidentDetails = lazy(
  () => import('modules/incidents/incidents-log/view-incident/Main')
);
/**
 * Main route configuration.
 * @returns {Object} The main route object.
 */

const MainRoutes = (): any => ({
  path: '',
  element: <MainWrapper />,
  children: [
    {
      path: 'incidents-log',
      element: <Incidents />,
    },
    {
      path: 'incidents-log/add',
      element: <AddIncidents />,
    },
    {
      path: 'incidents-log/edit/:incidentId',
      element: <AddIncidents />,
    },
    {
      path: 'incidents-log/:incidentId',
      element: <IncidentDetails />,
    },
    {
      path: 'incidents-dashboard',
      element: <IncidentsDashboard />,
    },
    {
      path: 'vulnerabilities',
      element: <Vulnerabilities />,
    },
    {
      path: 'vulnerabilities/:vulnerabilityId',
      element: <VulnerabilityDetail />,
    },
    {
      path: 'vulnerabilities/create',
      element: <FormVulnerability />,
    },
    {
      path: 'vulnerabilities/edit/:vulnerabilityId',
      element: <FormVulnerability />,
    },
    // {
    //     path: 'security',
    //     element: <UserSecurityPage />,
    // },
  ],
});

export default MainRoutes;
